<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><span><a href="#/toc#toc-preface002">PROLOGUE</a></span></h1>
<p class="noindent"><span class="drop-caps">J</span>ura, <a id="page_1"></a>April 1947. It was his third day back on the island but the first he had managed to get out of bed. He knew what he had to do: transfer to paper the ceaseless, grinding monologue that had been working through his mind since … when? His days at the BBC? The betrayal in Barcelona? The discovery of the proles in Wigan? Those glorious summers of his youth? Prep school and H.G. Wells? He couldn’t remember; perhaps the obsession had always been with him.</p>
<p>The view from his desk was desolate: the ground sodden and grassless, and the early spring flowers already spent. The late frosts and rains had played havoc with the place. He could see a dead calf in the next field, which meant rats. He roused himself and sat up straighter. Almost absentmindedly, he typed ‘i.’ at the top of the page.</p>
<p>He glanced at his watch. It was midday of the first day of Double Summer Time, meaning it was actually twelve plus one – or eleven plus two, depending on how you looked at it. What with the bolshiness of the islanders towards such matters, no one here could ever agree what time it really was. He took off his watch, wound it forward one hour and strapped it back on his wrist.</p>
<p>To mark the paper was the decisive act. He’d got somewhere the previous summer, but only with incidental parts, like Goldstein’s secret book, and they’d all have to be redone. Now he faced the hard part: <a id="page_2"></a>the story. <em>A Clergyman’s Daughter</em> and <em>Keep the Aspidistra Flying</em> he had opened with the ringing of clocks, and <em>Coming Up for Air</em> with George Bowling nipping out of bed. It was an easy way in – perhaps too easy, but he could get it right in the next draft. He felt a jolt in his chest and his mind drifted to his illness, but he regained control before the thoughts could lead anywhere.</p>
<p>Then the right words came, the way good writing always does, in a rush. He put his hands to the keys and the letters began to indent the paper:</p>
<div class="blockquote">
<div class="blockquote1">
<p class="noindent">It was a cold, blowy day in early April, and a million radios were striking thirteen.</p>
</div>
</div>
<p>He lit a cigarette and read the line over. Something wasn’t right. There was a looseness about it. Connolly would have attacked the scansion, just as he had all those years ago at prep. And the radios – they smacked of Wells and Huxley and science fiction, which was the last thing he wanted. He picked up his pen and began amending. Satisfied, he read it back again:</p>
<div class="blockquote">
<div class="blockquote1">
<p class="noindent">It was a bright cold day in April, and the clocks were striking thirteen.</p>
</div>
</div>
<p>There was no turning back now.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface002.vue?1868fb7d